export const checkinEditDrawer = {
  header: {
    title: "تعديل بيانات تسجيل الوصول",
    age: "العمر:",
    docNotRequiredMinor: "الوثيقة غير مطلوبة (قاصر)",
    docOptionalMinorES: "الوثيقة اختيارية (قاصر في إسبانيا)",
    docOptionalMinorCO: "الوثيقة اختيارية (أقل من 7 سنوات في كولومبيا)",
  },
  sections: {
    basicData: "البيانات الأساسية",
    stayDates: "تواريخ الإقامة",
    italyDoc: "الوثيقة وبلد الميلاد",
    doc: "الوثيقة والجنسية",
  },
  fields: {
    firstName: "الاسم",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    birthDate: "تاريخ الميلاد",
    sex: "الجنس",
    checkIn: "الدخول",
    checkOut: "الخروج",
    docType: "نوع الوثيقة",
    docNumber: "رقم الوثيقة",
    supportNumber: "رقم الدعم",
    nationality: "الجنسية",
  },
  placeholders: {
    select: "اختر",
    selectNationality: "اختر الجنسية",
    searchCountry: "ابحث عن بلد...",
    selectCountry: "— اختر بلداً —",
    docNumberExample: "مثال: AB1234567",
    docNumberGeneric: "DNI / NIE / جواز السفر",
    required: "إلزامي",
    optional: "اختياري",
  },
  sex: {
    male: "ذكر",
    female: "أنثى",
    preferNotToSay: "أفضّل عدم الإفصاح",
    other: "آخر",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "بلد الميلاد",
    birthCountryHint: "— يُستخدم أيضاً كجنسية",
    issuePlaceLabel: "مكان إصدار الوثيقة",
    issuePlaceHint: "— البلد الذي صدرت فيه الوثيقة",
    alloggiatiCode: "رمز Alloggiati:",
    iso3Label: "ISO3:",
    minorNote:
      "قاصر — يُرسَل نوع الوثيقة ورقمها ومكان إصدارها فارغة إلى Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "الوثيقة اختيارية حسب قاعدة العمر/البلد. يمكنك إكمالها على أي حال.",
  },
  docTypes: {
    it: {
      IDENT: "وثيقة هوية (IDENT)",
      IDELE: "وثيقة هوية إلكترونية (IDELE)",
      PASOR: "جواز سفر عادي (PASOR)",
      PASSE: "جواز سفر خدمة (PASSE)",
      PASDI: "جواز سفر دبلوماسي (PASDI)",
      PATEN: "رخصة قيادة (PATEN)",
      PATNA: "رخصة ملاحة بحرية (PATNA)",
      CIDIP: "هوية دبلوماسية (CIDIP)",
      RIFUG: "وثيقة سفر لاجئ (RIFUG)",
    },
    co: {
      CC: "بطاقة المواطنة",
      CE: "بطاقة الأجانب",
      P: "جواز السفر",
      PPT: "تصريح الحماية المؤقتة",
      PEP: "تصريح الإقامة الخاص",
      DE: "وثيقة أجنبية",
      CD: "بطاقة دبلوماسية",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "جواز السفر",
      OTRO: "أخرى",
    },
    generic: {
      ID: "وثيقة هوية",
      P: "جواز السفر",
      OTRO: "أخرى",
    },
  },
  footer: {
    cancel: "إلغاء",
    save: "حفظ",
    saving: "جارٍ الحفظ...",
  },
  errors: {
    nameRequired: "الاسم واسم العائلة إلزاميان.",
    emailInvalid: "بريد إلكتروني غير صالح.",
    phoneRequired: "الهاتف إلزامي.",
    birthDateRequired: "تاريخ الميلاد إلزامي.",
    sexRequired: "الجنس إلزامي.",
    stayDatesRequired: "تواريخ الإقامة إلزامية.",
    checkoutBeforeCheckin: "لا يمكن أن يكون تاريخ الخروج قبل تاريخ الدخول.",
    birthCountryRequired: "بلد الميلاد إلزامي.",
    docTypeRequired: "نوع الوثيقة إلزامي.",
    docNumberRequired: "رقم الوثيقة إلزامي.",
    issuePlaceRequired: "مكان إصدار الوثيقة إلزامي.",
    nationalityRequired: "الجنسية إلزامية.",
    supportNumberRequired:
      "رقم الدعم إلزامي للجنسية الإسبانية (البالغين).",
    saveFailed: "تعذّر الحفظ.",
    saveError: "حدث خطأ أثناء حفظ التغييرات.",
  },
  toast: {
    saved: "تم تحديث تسجيل الوصول بنجاح",
  },
};
